import React from "react";
import "./About.css";
import profilePic from "../../../images/jcover2.jpg";

const About = () => {
  return (
    <div className="about-seciton">
      <div className="container">
        <div className="row">
          <div className="col-md-6 pb-5">
            <img src={profilePic} className="aboutImg" alt="jubayer" /> <br />{" "}
            <br />
            {/* <span className="text-bright fw-bold">Hello, I'm</span> */}
            <h1>Showkat Jubayer</h1>
            {/* <strong className="text-bright">
              Web Developer, Programmer & Problem Solver
            </strong>{" "} */}
            {/* <br /> <br /> */}
            <p className="lead aboutTextDetails">
              I am a student of Psychology at the National University of
              Bangladesh. Also, I am a junior Front-end Web Developer. I have
              excellent programming knowledge and good analytical skills. I'm
              familiar with C/C++, Java, Python, Haskell, JavaScript, and
              TypeScript. Also, I can manage Git/Github. JavaScript is my
              favorite programming language. Also, I like TypeScript. I am
              comfortable working with JavaScript, React, Firebase, Node, and
              MongoDB. I love to solve problems in BeeCrowd, Hackerrank,
              Codeforces, and Edabit. Right now I am seeking a challenging yet
              rewarding career that provides the opportunity for development.
              Honesty and creativity are my policy. I like to read books and
              travelling.
            </p>{" "}
            <br />
            <a
              className="btn app-button"
              target="_blank"
              rel="noreferrer"
              href="https://drive.google.com/file/d/17vn6S8WUPGwbnxo7YiQCTPiBBR2Q47MM/view?usp=sharing"
            >
              Download Resume
            </a>
          </div>
          <div className="col-md-4 offset-md-2">
            <h5>My Skills Set</h5>
            <span className="badge app-badge m-1">React JS</span>
            <span className="badge app-badge m-1">Next JS</span>
            <span className="badge app-badge m-1">JavaScript</span>
            <span className="badge app-badge m-1">ES6</span>
            <span className="badge app-badge m-1">TypeScript</span>
            <span className="badge app-badge m-1">NodeJS</span>
            <span className="badge app-badge m-1">ExpressJS</span>
            <span className="badge app-badge m-1">MongoDB</span>
            <span className="badge app-badge m-1">Firebase</span>
            <span className="badge app-badge m-1">Git</span>
            <span className="badge app-badge m-1">Github</span>
            <span className="badge app-badge m-1">NPM</span>
            <span className="badge app-badge m-1">C</span>
            <span className="badge app-badge m-1">C++</span>
            <span className="badge app-badge m-1">Haskell</span>
            <span className="badge app-badge m-1">Python</span>
            <br /> <br /> <br />
            <h5>I Want to work with</h5>
            <span className="badge app-badge m-1">ReactJS</span>
            <span className="badge app-badge m-1">Firebase</span>
            <span className="badge app-badge m-1">JavaScript</span>
            <span className="badge app-badge m-1">TypeScript</span>
            <span className="badge app-badge m-1">Angular</span>
            {/* <span className="badge app-badge m-1">Vue</span> */}
            <span className="badge app-badge m-1">MERN Stack</span>
            <span className="badge app-badge m-1">Front-end Development</span>
            <br /> <br /> <br />
            {/* <h5>I prefer not to work with</h5>
                        <span className="badge app-badge m-1">PHP</span>
                        <span className="badge app-badge m-1">Laravel</span>
                        <span className="badge app-badge m-1">MySQL</span>
                        <span className="badge app-badge m-1">WordPress</span>
                        <span className="badge app-badge m-1">jQuery</span> */}
            <h5>Social Contact</h5>
            <ul>
              <li>
                <a
                  rel="noreferrer"
                  target="_blank"
                  href="https://github.com/jubayerr"
                >
                  <i class="fab fa-github aboutIcon"></i>
                </a>
              </li>
              <li>
                <a
                  rel="noreferrer"
                  target="_blank"
                  href="https://www.linkedin.com/in/showkatjubayer"
                >
                  <i class="fab fa-linkedin aboutIcon"></i>
                </a>
              </li>
              <li>
                <a
                  rel="noreferrer"
                  target="_blank"
                  href="https://twitter.com/jubayerweb"
                >
                  <i class="fab fa-twitter aboutIcon"></i>
                </a>
              </li>
              <li>
                <a
                  rel="noreferrer"
                  target="_blank"
                  href="https://www.facebook.com/showkatjubayer/"
                >
                  <i class="fab fa-facebook-square aboutIcon"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
